import { Col, Row } from 'antd'
import React from 'react'

import { FileDisplay } from '@/components'
import { FileSetState } from '@/components/file-upload-button/file-upload.state'
import { LocalFileFragment, useGetViewerFilesQuery } from '@/generated/graphql'

import s from './post-editor.module.less'
import { PostEditorSetState } from './post-editor.state'

interface EditorFilesProps {
  files: LocalFileFragment[]
  setState: PostEditorSetState | FileSetState
}

export const PostEditorFiles: React.FC<EditorFilesProps> = ({ files, setState }) => {
  const hasExpiredFiles = files.some((f) => new Date() >= new Date(f.oss.expireAt))

  // 如果 localStorage 中的文件过期了，则重新从数据库拿新的 oss signature
  const { data } = useGetViewerFilesQuery({
    skip: !hasExpiredFiles,
    variables: {
      fileIds: files.map(({ fileId }) => fileId),
      pagination: {
        first: files.length,
      },
    },
  })

  React.useEffect(() => {
    if (!data) {
      return
    }
    setState((state: any) => ({ ...state, files: data.viewer.files.edges.map(({ node }) => node) }))
  }, [data])

  if (files.length === 0) {
    return null
  }

  const onDeleteFile = (file: LocalFileFragment) => {
    setState((state: any) => ({ ...state, files: state.files.filter((f: any) => f.fileId !== file.fileId) }))
  }

  const isImage = (f: LocalFileFragment) => f.type.split('/')[0] === 'image'
  const images = files.filter(isImage)
  const fileComponents = files.map((f) => {
    return (
      <Col key={f.fileId} span={isImage(f) ? 12 : 24}>
        <FileDisplay
          file={f}
          images={images}
          width='100%'
          height='auto'
          showClose
          onClose={() => onDeleteFile(f)}
          progress={f['progress']}
        />
      </Col>
    )
  })

  return (
    <div className={s.filesContainer}>
      <Row gutter={[8, 8]}>{fileComponents}</Row>
    </div>
  )
}
